<template>
    <div class="signup-page">
        <section>
            <div class="page-container">
                <h1 class="eyebrow-page fw-semibold omnes">
                    <span class="omnes">Make JORNAY PM your first-choice long-acting
                        methylphenidate</span>
                </h1>
            </div>
        </section>

        <section class="sign-up-container">
            <div class="page-container">
                <validation-observer v-slot="{ validate, errors, invalid, failed, changed }" ref="observer">
                    <form ref="form" @submit.prevent="validate().then(afterValidation)" :action="ironshoreContactMethod === 'Copay Cards'
                            ? pardotCoPayFormHandlerUrl
                            : pardotFormHandlerUrl
                        " method="post">
                        <!-- {{ (errors, invalid) }} -->

                        <validation-provider name="Contact method" rules="contactMethodsSelected:receiveUpdates"
                            v-slot="{ errors, invalid }">
                            <div class="checkbox-group">
                                <div>
                                    <span class="fw-bold checkbox-group__title">Select all that apply:</span>

                                    <div class="checkbox-group__list">
                                        <div class="checkbox-group__box">
                                            <Checkbox id="copay-card" v-model="ironshoreContactMethod"
                                                inputId="copay-card" name="contactMethod" value="Copay Cards" />

                                            <label for="copay-card" class="">
                                                Receive materials to help
                                                educate your patients about
                                                <span class="text-nowrap">JORNAY PM</span>
                                            </label>
                                        </div>

                                        <div>
                                            <div class="checkbox-group__box">
                                                <Checkbox id="rep" v-model="ironshoreContactMethod
                                                    " inputId="rep" name="contactMethod"
                                                    value="Ironshore Representative" />

                                                <label for="rep" class="">
                                                    Learn more about <span class="text-nowrap">JORNAY PM.</span>
                                                    Connect with a Collegium
                                                    sales representative
                                                </label>
                                            </div>

                                            <!-- <p v-if="
                                                ironshoreContactMethod &&
                                                ironshoreContactMethod.includes(
                                                    'Ironshore Representative'
                                                )
                                            ">
                                                By making this selection, you
                                                are giving Collegium
                                                Pharmaceutical, Inc. permission
                                                to contact you with the
                                                information you have requested.
                                                Collegium Pharmaceutical, Inc.
                                                will not sell or lease any of
                                                your information to third
                                                parties.
                                                <a href="https://www.collegiumpharma.com/privacy-policy/"
                                                    target="_blank" rel="noopener noreferrer">
                                                    View our privacy policy</a>.
                                            </p> -->
                                        </div>

                                        <!-- <div>
                                            <div class="checkbox-group__box">
                                                <Checkbox
                                                    id="medical"
                                                    v-model="
                                                        ironshoreContactMethod
                                                    "
                                                    inputId="medical"
                                                    name="contactMethod"
                                                    value="Medical Liason"
                                                />

                                                <label for="medical" class="">
                                                    Connect with a Medical
                                                    Science Liaison for
                                                    questions regarding clinical
                                                    characteristics or trial
                                                    data for JORNAY PM
                                                </label>
                                            </div>

                                            <p
                                                v-if="
                                                    ironshoreContactMethod &&
                                                    ironshoreContactMethod.includes(
                                                        'Medical Liason'
                                                    )
                                                "
                                            >
                                                By making this selection, you
                                                are giving Collegium
                                                Pharmaceutical, Inc. permission
                                                to contact you with the
                                                information you have requested.
                                                Collegium Pharmaceutical, Inc.
                                                will not sell or lease any of
                                                your information to third
                                                parties.
                                                <a
                                                    href="https://www.collegiumpharma.com/privacy-policy/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    View our privacy policy</a
                                                >.
                                            </p>
                                        </div> -->
                                    </div>

                                    <div class="safety-information">
                                        <p>
                                            <strong>
                                                Please see <a @click="handleExternalLinkClick">Important Safety Information</a>
                                                including Boxed Warning and

                                                <a target="_blank" rel="noopener noreferrer"
                                                    href="https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf">Full
                                                    Prescribing
                                                    Information</a>.
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </validation-provider>

                        <span class="required-text">*Required Field</span>

                        <div class="form-bottom">
                            <validation-provider name="salutation" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element">
                                    <label for="title"><strong>Title</strong>
                                        (optional)</label>

                                    <Dropdown inputId="title" id="title" v-model="selectedSalutation"
                                        :options="salutations" optionLabel="name" class="dropdown" />
                                </div>
                            </validation-provider>

                            <validation-provider name="f_name" rules="required" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element-container">
                                    <div :class="{
                                        'form-element input input-error':
                                            failed &&
                                            (changed || validated),
                                        'form-element input': !(
                                            failed &&
                                            (changed || validated)
                                        ),
                                    }">
                                        <label class="label-input" for="name">First name*</label>
                                        <input type="text" name="f_name" id="name" v-model="firstName" />
                                    </div>

                                    <p class="error-text" v-if="failed && (changed || validated)">
                                        Please enter your first name
                                    </p>
                                </div>
                            </validation-provider>

                            <validation-provider name="l_name" rules="required" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element-container">
                                    <div :class="{
                                        'form-element input input-error':
                                            failed &&
                                            (changed || validated),
                                        'form-element input': !(
                                            failed &&
                                            (changed || validated)
                                        ),
                                    }">
                                        <label class="label-input" for="last-name">Last name*</label>

                                        <input type="text" name="l_name" id="last-name" v-model="lastName" />
                                    </div>

                                    <p class="error-text" v-if="failed && (changed || validated)">
                                        Please enter your last name
                                    </p>
                                </div>
                            </validation-provider>

                            <validation-provider name="Specialty" rules="required" ref="specialtyProvider" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element-container">
                                    <div :class="{
                                        'form-element input input-error specialty':
                                            failed &&
                                            (changed || validated),
                                        'form-element input specialty': !(
                                            failed &&
                                            (changed || validated)
                                        ),
                                    }">
                                        <label for="specialty"><strong>Specialty*</strong>
                                        </label>

                                        <Dropdown inputId="specialty" id="specialty" v-model="selectedSpecialty"
                                            :options="specialties" optionLabel="name" class="dropdown specialty"
                                            @hide="dropdownHidden" />
                                    </div>

                                    <p class="error-text" v-if="failed && (changed || validated)">
                                        Please select a specialty
                                    </p>
                                </div>
                            </validation-provider>

                            <div class="address" v-if="isCopayCardsMethodSelected">
                                <p class="fw-bold address-title">
                                    Shipping Address (we will not use this
                                    address in the future):
                                </p>

                                <div class="address-type">
                                    <validation-provider name="addressLocation"
                                        rules="copayCardsInfoRequired:contactMethod" v-slot="{ errors, invalid }">
                                        <div class="radio-input">
                                            <RadioButton id="home" inputId="home" name="Address_Location" value="Home"
                                                v-model="addressLocation" />

                                            <label for="home">
                                                <span class="address-type-title">Home</span>

                                                <p>
                                                    Your materials will be mailed to
                                                    your home within five
                                                    business days. We will not
                                                    retain your home address in
                                                    our records.
                                                </p>
                                            </label>
                                        </div>

                                        <div class="radio-input">
                                            <RadioButton id="work" inputId="work" name="Address_Location" value="Work"
                                                v-model="addressLocation" />

                                            <label for="work">
                                                <span class="address-type-title">Work</span>

                                                <p>
                                                    Your materials will be shipped
                                                    or delivered directly to
                                                    your office by your sales
                                                    representative.
                                                </p>
                                            </label>
                                        </div>
                                    </validation-provider>

                                    <div class="address-text">
                                        <!-- <validation-provider name="company"
                                            rules="required|copayCardsInfoCompanyRequired:addressLocation" v-slot="{
                                                errors,
                                                invalid,
                                                failed,
                                                changed,
                                                validated,
                                            }"> -->
                                            <div class="form-element-container">
                                                <!-- <div :class="{
                                                    'form-element input input-error':
                                                        failed &&
                                                        (changed ||
                                                            validated),
                                                    'form-element input': !(
                                                        failed &&
                                                        (changed ||
                                                            validated)
                                                    ),
                                                }"> -->
                                                <div class="form-element input">

                                                    <label class="label-input" for="company">Company Name</label>

                                                    <input type="text" name="company" id="company" v-model="company" />
                                                </div>

                                                <!-- <p class="error-text" v-if="
                                                    failed &&
                                                    (changed || validated)
                                                ">
                                                    Please enter your company
                                                    name
                                                </p> -->
                                            </div>
                                        <!-- </validation-provider> -->

                                        <validation-provider name="address1" rules="required" v-slot="{
                                            errors,
                                            invalid,
                                            failed,
                                            changed,
                                            validated,
                                        }">
                                            <div class="form-element-container">
                                                <div :class="{
                                                    'form-element input input-error':
                                                        failed &&
                                                        (changed ||
                                                            validated),
                                                    'form-element input': !(
                                                        failed &&
                                                        (changed ||
                                                            validated)
                                                    ),
                                                }">
                                                    <label class="label-input" for="address1">Address Line 1*</label>

                                                    <input type="text" name="address1" id="address1"
                                                        v-model="address1" />
                                                </div>

                                                <p class="error-text" v-if="
                                                    failed &&
                                                    (changed || validated)
                                                ">
                                                    Please enter your address
                                                    line 1
                                                </p>
                                            </div>
                                        </validation-provider>

                                        <validation-provider name="address2" v-slot="{
                                            errors,
                                            invalid,
                                            failed,
                                            changed,
                                            validated,
                                        }">
                                            <div class="form-element input">
                                                <label class="label-input" for="address2">Address Line 2</label>

                                                <input type="text" name="address2" id="address2" v-model="address2" />
                                            </div>
                                        </validation-provider>

                                        <validation-provider name="city" rules="required" v-slot="{
                                            errors,
                                            invalid,
                                            failed,
                                            changed,
                                            validated,
                                        }">
                                            <div class="form-element-container">
                                                <div :class="{
                                                    'form-element input input-error':
                                                        failed &&
                                                        (changed ||
                                                            validated),
                                                    'form-element input': !(
                                                        failed &&
                                                        (changed ||
                                                            validated)
                                                    ),
                                                }">
                                                    <label class="label-input" for="city">City*</label>

                                                    <input type="text" name="city" id="city" v-model="city" />
                                                </div>

                                                <p class="error-text" v-if="
                                                    failed &&
                                                    (changed || validated)
                                                ">
                                                    Please enter your city
                                                </p>
                                            </div>
                                        </validation-provider>

                                        <validation-provider name="state" ref="stateProvider" rules="required" v-slot="{
                                            errors,
                                            invalid,
                                            failed,
                                            changed,
                                            validated,
                                        }">
                                            <div class="form-element-container">
                                                <div :class="{
                                                    'form-element input input-error state':
                                                        failed &&
                                                        (changed ||
                                                            validated),
                                                    'form-element input state':
                                                        !(
                                                            failed &&
                                                            (changed ||
                                                                validated)
                                                        ),
                                                }">
                                                    <label for="title"><strong>State*</strong>
                                                    </label>

                                                    <Dropdown inputId="state" id="state" v-model="selectedState"
                                                        :options="states" optionLabel="Code" class="dropdown" @hide="
                                                            dropdownStateHidden
                                                        " />
                                                </div>

                                                <p class="error-text" v-if="
                                                    failed &&
                                                    (changed || validated)
                                                ">
                                                    Please select your state
                                                </p>
                                            </div>
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>

                            <validation-provider name="zip" rules="required|length:5" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element-container input zipcode">
                                    <div :class="{
                                        'form-element input input-error zipcode':
                                            failed &&
                                            (changed || validated),
                                        'form-element input zipcode': !(
                                            failed &&
                                            (changed || validated)
                                        ),
                                    }">
                                        <label class="label-input" for="zipcode">ZIP Code*</label>

                                        <input type="text" name="zip" id="zipcode" v-model="zipCode" maxlength="5"
                                            @keypress="validateInput" />
                                    </div>

                                    <p class="error-text" v-if="failed && (changed || validated)">
                                        Please enter a valid ZIP Code
                                    </p>
                                </div>
                            </validation-provider>

                            <validation-provider name="email" rules="required|email" v-slot="{
                                errors,
                                invalid,
                                failed,
                                changed,
                                validated,
                            }">
                                <div class="form-element-container input">
                                    <div :class="{
                                        'form-element input input-error':
                                            failed &&
                                            (changed || validated),
                                        'form-element input': !(
                                            failed &&
                                            (changed || validated)
                                        ),
                                    }">
                                        <label class="label-input" for="email">Email address*</label>
                                        <input type="text" name="email" id="email" v-model="email" />
                                    </div>

                                    <p class="error-text" v-if="failed && (changed || validated)">
                                        Please enter a valid email address
                                    </p>
                                </div>
                            </validation-provider>

                            <div class="contact" v-show="ironshoreContactMethod != null">
                                <p class="fw-bold">
                                    Preferred method of contact
                                </p>

                                <validation-provider name="preferredMethod" v-slot="{ errors, invalid }"
                                    :disabled="ironshoreContactMethod == null">
                                    <div class="radio-input">
                                        <RadioButton id="email-check" inputId="email-check" name="preferredMethod"
                                            value="email" v-model="preferredContactMethod" />

                                        <label for="email-check">
                                            <span class="address-type-title">Email</span>
                                        </label>
                                    </div>

                                    <div class="radio-input">
                                        <RadioButton id="phoneCheck" inputId="phoneCheck" name="preferredMethod"
                                            value="phone" v-model="preferredContactMethod" />

                                        <label for="phoneCheck">
                                            <span class="address-type-title">Phone</span>
                                        </label>
                                    </div>
                                </validation-provider>

                                <validation-provider name="phone" rules="required|length:10" v-slot="{
                                    errors,
                                    invalid,
                                    failed,
                                    changed,
                                    validated,
                                }" v-show="isPhoneContactSelected" :disabled="!isPhoneContactSelected">
                                    <div class="form-element-container input phone">
                                        <div :class="{
                                            'form-element input input-error phone':
                                                failed &&
                                                (changed || validated),
                                            'form-element input phone': !(
                                                failed &&
                                                (changed || validated)
                                            ),
                                        }">
                                            <label class="label-input" for="phone">Phone number*</label>

                                            <input type="text" name="phone" id="phone" maxlength="10"
                                                v-model="phoneNumber" @keypress="validateInput" />
                                        </div>

                                        <p class="error-text" v-if="
                                            failed && (changed || validated)
                                        ">
                                            Please enter a valid phone number
                                        </p>
                                    </div>
                                </validation-provider>
                            </div>

                            <div class="checkbox-group checkbox-group--one checkbox-group-updates">
                                <div class="checkbox-group__list">
                                    <!-- <validation-provider
                                        name="certifyUpdates"
                                        rules="receiveUpdatesSelected:contactMethod"
                                        v-slot="{
                                            errors,
                                            invalid,
                                            failed,
                                            changed,
                                            validated,
                                        }"
                                    >
                                        <div>
                                            <div
                                                :class="{
                                                    'checkbox-group__box input-error':
                                                        failed &&
                                                        (changed || validated),
                                                    'checkbox-group__box': !(
                                                        failed &&
                                                        (changed || validated)
                                                    ),
                                                }"
                                            >
                                                <Checkbox
                                                    id="certifySelected"
                                                    inputId="certifySelected"
                                                    v-model="certifySelected"
                                                    name="certifySelected"
                                                    :binary="true"
                                                />

                                                <label
                                                    for="certifySelected"
                                                    class="updates"
                                                >
                                                    I certify that I am a US
                                                    healthcare professional. I
                                                    understand that any services
                                                    and information provided are
                                                    not intended as an improper
                                                    inducement but are intended
                                                    to assist me in forming my
                                                    own conclusions and making
                                                    my own decisions.*
                                                </label>
                                            </div>

                                            <p
                                                class="error-text"
                                                v-if="
                                                    failed &&
                                                    (changed || validated)
                                                "
                                            >
                                                Please check box to continue.
                                            </p>
                                        </div>
                                    </validation-provider> -->

                                    <input type="hidden" name="profile_type" :value="isCopayCardsMethodSelected // &&certifySelected
                                            ? 'Healthcare Professional'
                                            : null
                                        " />

                                    <validation-provider name="Receive updates" v-slot="{ errors }">
                                        <div class="checkbox-group__box">
                                            <Checkbox id="updates" inputId="updates" v-model="receiveEmailSelected"
                                                name="receiveUpdates" :binary="true" />

                                            <label for="updates" class="updates">
                                                I’d like to receive email
                                                updates about JORNAY PM
                                                <span class="fw-normal">
                                                    (optional).
                                                </span>
                                            </label>
                                        </div>
                                    </validation-provider>
                                </div>

                                <div class="checkbox-note">
                                    <p class="p-0">
                                        Your information will never be shared or
                                        sold to a third party.
                                        Click <a href="https://www.collegiumpharma.com/privacy-policy/"
                                            rel="noreferrer noopener" target="_blank">here</a> 
                                        for our privacy policy. If your request
                                        is related to a product complaint or
                                        adverse event involving JORNAY PM,
                                        please contact Collegium Medical
                                        Information directly at
                                        <a href="mailto:drugsafety@propharmagroup.com">drugsafety@propharmagroup.com</a> or call
                                        1-855-331-5615. FDA MedWatch can be
                                        contacted directly at:
                                        <a
                                            href="https://www.accessdata.fda.gov/scripts/medwatch/index.cfm">https://www.accessdata.fda.gov/scripts/medwatch/index.cfm</a>
                                        or by calling 1-800-FDA-1088
                                        (1-800-332-1088).
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="submit-container">
                            <button type="submit" class="submit fw-bold">
                                <span>Send request</span>
                            </button>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </section>
        <div class="blue-line"></div>
    </div>
</template>

<script>
import { extend, localize, setInteractionMode } from 'vee-validate';
import { states } from '../models/states';
import headers from '../models/headers';
import axios from 'axios';
import qs from 'query-string';

import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import DropdownForm from '../components/DropdownForm.vue';
import TextboxForm from '../components/TextboxForm.vue';

setInteractionMode('eager');

extend('contactMethodsSelected', {
    validate: (value, { target }) => {
        return value != null || target === true;
    },
    params: [
        {
            name: 'target',
            isTarget: true,
        },
    ],
    computesRequired: true,
});

extend('receiveUpdatesSelected', {
    validate: (value, { target }) => {
        return value === true || target != null;
    },
    params: [
        {
            name: 'target',
            isTarget: true,
        },
    ],
    computesRequired: true,
});

extend('copayCardsInfoRequired', {
    validate: (value, { target }) => {
        return target !== 'Copay Cards' || (value != null && value !== '');
    },
    params: [
        {
            name: 'target',
            isTarget: true,
        },
    ],
    computesRequired: true,
});

// extend('copayCardsInfoCompanyRequired', {
//     validate: (value, { target }) => {
//         return (
//             target == null ||
//             target !== 'Work' ||
//             (value != null && value !== '')
//         );
//     },
//     params: [
//         {
//             name: 'target',
//             isTarget: true,
//         },
//     ],
//     computesRequired: true,
// });

export default {
    components: {
        Dropdown,
        Checkbox,
        RadioButton,
        DropdownForm,
        TextboxForm,
    },
    metaInfo: headers.signUpPage(),
    data() {
        return {
            ironshoreContactMethod: null,
            pardotFormHandlerUrl:
                'https://www2.ironshorepharma.com/l/231552/2019-05-14/fl2m4', // prod
            pardotCoPayFormHandlerUrl:
                'https://go.pardot.com/l/231552/2020-05-27/tg2lg', //prod
            //pardotFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-11/t7vpj", // uat
            //pardotCoPayFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-19/tb2f6", // uat
            //pardotFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-11/t7r1s", // dev
            //pardotCoPayFormHandlerUrl : "https://go.pardot.com/l/231552/2020-05-19/tb1rj", // dev
            selectedQuantity: null,
            company: null,
            addressLocation: null,
            address2: null,
            address1: null,
            city: null,
            // certifySelected: '',
            quantities: [5, 10, 15],
            salutations: [
                { name: 'Dr.' },
                { name: 'Mr.' },
                { name: 'Mrs.' },
                { name: 'Ms.' },
            ],
            specialties: [
                { name: 'Pediatrician' },
                { name: 'Family Practice' },
                { name: 'Internal Medicine' },
                { name: 'General Psychiatrist' },
                { name: 'Pediatric Psychiatrist' },
                { name: 'NP/PA' },
                { name: 'Other' },
            ],
            states: states.map((s) => ({ Code: s.Code })),
            selectedSalutation: null,
            selectedState: null,
            firstName: null,
            lastName: null,
            email: null,
            zipCode: null,
            preferredContactMethod: null,
            phoneNumber: null,
            receiveEmailSelected: false,
            contactMethodError: '',
            selectedSpecialty: null,
        };
    },
    methods: {
        async afterValidation(isValid) {
            // console.log(isValid, this.isCopayCardsMethodSelected, '<---------');

            if (isValid) {
                this.contactMethodError = '';
                sessionStorage.removeItem('state');
                sessionStorage.removeItem('copayCardsSelected');
                if (!this.isCopayCardsMethodSelected) {
                    //do not submit values if an user selects Copay cards, fills info, and then selects another option
                    this.selectedState = null;
                    this.address1 = null;
                    this.address2 = null;
                    this.city = null;
                    this.addressLocation = null;
                    this.company = null;
                    if (this.isMSLMethodSelected) {
                        await this.getState();
                    }
                } else {
                    sessionStorage.setItem('copayCardsSelected', true);
                }

                // Send to CDW
                // if (this.isCopayCardsMethodSelected) {

                var aws =
                    'https://0cpvr1wr3m.execute-api.us-east-1.amazonaws.com/api/form-submission';
                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                };
                axios
                    .post(
                        aws,
                        qs.stringify({
                            contactMethod: this.contactMethodsSelected,
                            // Number_of_Copay_Cards_Requested:
                            //     this.$refs.form
                            //         .Number_of_Copay_Cards_Requested.value, //NOT WORKING
                            salutation: this.selectedSalutation,
                            f_name: this.firstName,
                            l_name: this.lastName,
                            Specialty: this.selectedSpecialty,
                            Address_Location: this.addressLocation,
                            company: this.company,
                            address1: this.address1,
                            address2: this.address2,
                            city: this.city,
                            state: this.selectedState,
                            zip: this.zipCode,
                            email: this.email,
                            preferredMethod:
                                this.$refs.form.preferredMethod.value,
                            phone: this.phoneNumber,
                            // certifySelected: this.certifySelected,
                            profile_type: this.$refs.form.profile_type.value,
                            receiveUpdates: this.receiveUpdates,
                            contactMethod: this.ironshoreContactMethod,
                        }),
                        config
                    )
                    .then((response) => {
                        console.log(response);

                        // this.$router.push('/thank-you');
                    })
                    .catch((e) => {
                        console.log(error);
                    });
                // }

                this.$refs.form.submit();

                this.$router.push('/thank-you');
            }
        },
        async getState() {
            const res = await axios.get(url + this.zipCode);
            if (res != null) {
                sessionStorage.setItem('state', res.data.places[0].state);
            }
            return true;
        },
        validateInput(ev) {
            var charCode = ev.which ? ev.which : ev.keyCode;
            if (
                charCode > 31 &&
                (charCode < 44 || charCode > 57) &&
                charCode !== 46
            ) {
                ev.preventDefault();
            } else {
                return true;
            }
        },
        dropdownHidden() {
            this.$refs.specialtyProvider.validate();
        },
        dropdownStateHidden() {
            this.$refs.stateProvider.validate();
        },
        handleExternalLinkClick() {
            this.$root.$emit('toggle-widget'); // Emit event globally
        },
    },
    computed: {
        isPhoneContactSelected() {
            return this.preferredContactMethod === 'phone';
        },
        isCopayCardsMethodSelected() {
            return (
                this.ironshoreContactMethod &&
                this.ironshoreContactMethod.includes('Copay Cards')
            );
        },
        isMSLMethodSelected() {
            return this.ironshoreContactMethod === 'Medical Liason';
        },
    },
};
</script>
